<template>
  <section v-loading.fullscreen.lock="loading" class="square">
    <el-backtop target=".square" :bottom="100" :visibility-height="1" />
    <div class="square-search bar">
      <!-- <com-search-bar :list="searchData" :list1="classify2" @search="handleSearch" /> -->
      <div v-for="(item,index) in searchData" :key="index" style="margin-top:10px">
        <el-button class="titles" :class="requestParams2.category_1 == null ? 'activeTab' :''" @click="handleSearch(null,'title')">
          学段 :
        </el-button>
        <section class="content">
          <el-button
            v-for="item1 in item.children" :key="item1.id"
            :class="requestParams2.category_1 == item1.id ? 'activeTab' :''"
            @click="handleSearch(item1.id,'classify1')">
            {{ item1.name }}
          </el-button>
        </section>
      </div>
      <section v-if="classify2">
        <div v-for="(item,index) in classify2" :key="index">
          <el-button class="titles" :class="requestParams2.category_2 == null ? 'activeTab' :''" @click="handleSearch(null,'kinds')">
            类型 :
          </el-button>
          <section class="content">
            <el-button
              v-for="item1 in item.children"
              :key="item1.id"
              :class="requestParams2.category_2 == item1.id ? 'activeTab' :''"
              @click="handleSearch(item1.id,'classify2')">
              {{ item1.name }}
            </el-button>
          </section>
        </div>
      </section>
      <section>
        <div v-for="(item,index) in classify3" :key="index">
          <section v-if="item.children" class="classify3content">
            <el-button class="titles" :class="requestParams2.category_3 == null ? 'activeTab' :''" @click="handleSearch(null,'classroom')">
              教室 :
            </el-button>
            <section class="content">
              <el-button
                v-for="item1 in item.children"
                :key="item1.id"
                :class="requestParams2.category_3 == item1.id ? 'activeTab' :''"
                @click="handleSearch(item1.id,'classify3')">
                {{ item1.name }}
              </el-button>
            </section>
          </section>
        </div>
      </section>
    </div>
    <div class="square-title">
      <com-tabs
        :list="squareInfo.obj.tabs"
        class="square-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="square-tabs-item"
          >
            <img
              :src="
                require(`@/assets/icon/icon-${
                  obj.name == '漫游' ? 'roam3' : 'img3'
                }.png`)
              "
              alt=""
            >
            <span>{{ obj.name }}</span>
          </div>
        </template>
      </com-tabs>
    </div>
    <div v-if="activeTab == 0" class="square-data">
      <template v-if="data2&&data2.length">
        <div v-for="(item2, index2) in data2" :key="index2" class="cell-item">
          <com-card3
            :obj="item2"
            img-height="217px"
            class="comCard2"
            @control="handleControl"
            @control1="handleControl1"
            @path="handleRouteDto"
          />
        </div>
        <div class="cell-item" />
      </template>
      <template v-else>
        <div class="nullData">
          <NullData
            text="相关空间正在更新中,敬请期待!"
          />
        </div>
      </template>
    </div>
    <div v-else class="square-data">
      <template v-if="data3 && data3.length">
        <div v-for="(item3, index3) in data3" :key="index3" class="cell-item">
          <com-card3
            class="comCard2"
            :obj="item3"
            img-height="217px"
            @control="handleControl"
            @control1="handleControl1"
            @path="handleRouteDto"
          />
        </div>
        <div class="cell-item" />
      </template>
      <template v-else>
        <div class="nullData">
          暂无收藏数据
        </div>
      </template>
    </div>
    <el-dialog
      title=" "
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="handleClose"
    >
      <iframe :src="pathValue" frameborder="0" width="100%" height="100%" />
    </el-dialog>
  </section>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comSearchBar from '@/components/comSearchBar'
import comTabs from '@/components/comTabs'
import comCard3 from '@/components/comCard3'
import NullData from '@/components/NullData'
export default {
  components: { comSearchBar, comTabs, comCard3, NullData },
  data() {
    return {
      squareInfo: mock.square.square.viewInfo,
      searchData: null,
      classify2: null,
      classify3: null,
      requestParams2: {
        page: 1,
        page_size: 100000
      },
      searchParams2: {},
      requestParams3: {
        collection_type: 2,
        page: 1,
        page_size: 100000
      },
      searchParams3: {},
      requestParams4: {
        collection_id: null,
        collection_type: 2
      },
      data2: null,
      data3: null,
      loading: false,
      equipInit: mock.square.square.init,
      activeTab: 0,
      activeTab0: '0-0',
      activeTab1: '1-0',
      activeTab2: '2-0',
      timer: null,
      dialogVisible: false,
      pathValue: '',
      params: {
        category_id: null
      }
    }
  },
  computed: {
    itemWidth() {
      return 78.75 * (document.documentElement.clientWidth / 375)
    }
  },
  async created() {
    this.loading = true
    // this.init();
    // 筛选项
    this.handleSearch()
  },
  mounted() {

  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    async init() {
      this.loading = true
      if (this.activeTab == 0) {
        // 列表数据-全部
        const obj2 = await this.equipInit.spaces(this.requestParams2)
        this.data2 = obj2.data
      } else {
        var collectList = []
        collectList = await this.equipInit.spaces1(this.requestParams3)
        this.data3 = collectList.reverse()
        // 列表数据-已经收藏
        // this.timer = setInterval(() => {
        //   setTimeout(async() => {
        //     var collectList = []
        //     collectList = await this.equipInit.spaces1(this.requestParams3)
        //     this.data3 = collectList.reverse()
        //   }, 0)
        // }, 1000)
      }
      this.loading = false
    },
    changeTab(x, y) {
      this.activeTab = x
      this.init()
    },
    async handleSearch(v, x, y, z) {
      this.params.category_id = v
      var obj = {}
      obj.category_id = v
      api.square.retrieve.conditions(obj).then((res) => {
        if (x == undefined) {
          this.searchData = res.data
        } else if (x == 'classify1') {
          this.classify2 = res.data
          this.requestParams2.category_1 = v
          this.requestParams2.category_2 = null
          this.requestParams2.category_3 = null
          this.classify3 = null
        } else if (x == 'classify2') {
          this.classify3 = res.data
          this.requestParams2.category_2 = v
          this.requestParams2.category_3 = null
        } else if (x == 'title') {
          this.requestParams2.category_1 = null
          this.classify2 = null
          this.classify3 = null
          this.requestParams2.category_3 = null
          this.requestParams2.category_2 = null
        } else if (x == 'classify3') {
          this.requestParams2.category_3 = v
        } else if (x == 'kinds') {
          this.requestParams2.category_2 = null
        } else if (x == 'classroom') {
          this.requestParams2.category_3 = null
        }
        this.init()
      })
    },
    gradeFilter(obj, arr) {
      const newArr = arr.filter((item) => {
        return item.grade_id == obj.grade
      })
      return newArr
    },
    srcAreaFilter(obj, arr) {
      const str1 = obj.design_src_area.split('-')[0]
      const str2 = obj.design_src_area.split('-')[1]
      const newArr = arr.filter((item) => {
        return item.src_area >= str1 && item.src_area <= str2
      })
      return newArr
    },
    categoryFilter(obj, arr) {
      const newArr = arr.filter((item) => {
        return item.category_id == obj.category
      })
      return newArr
    },
    handleRouteDto(v) {
      if (v.dataType == 'true') {
        this.$router.push({
          path: '/square/details',
          query: {
            id: v.dtoId
          }
        })
      } else {
        this.$router.push({
          path: '/roam',
          query: {
            src: v.design_pano_url_ai
          }
        })
      }
    },
    handleControl1(v) {
      this.requestParams4.collection_id = v.id
      const obj = {}
      obj.design_id = v.new_design_id
      obj.dest = 1
      api.square.update.dto(obj).then((res) => {
        this.pathValue = res.data.url
        this.dialogVisible = true

        // this.$router.push({
        //   path: '/square/set',
        //   query: {
        //     src: res.data.url
        //   }
        // })
      })
    },
    handleClose() {
      this.dialogVisible = false
      this.pathValue = ''
    },
    handleControl(v) {
      this.requestParams4.collection_id = v.id
      if (v.is_collection == 0) {
        this.$confirm('确认收藏吗？', '提示', {})
          .then(() => {
            api.mine.create.collect(this.requestParams4).then((res) => {
              this.$message.success('收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      } else {
        this.requestParams4.collection_id = v.dtoId
        this.$confirm('确认取消收藏吗?', '提示', {})
          .then(() => {
            api.mine.delete.collect(this.requestParams4).then((res) => {
              this.$message.success('取消收藏成功')
              this.init()
            })
          })
          .catch(() => {})
      }
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>

<style scoped lang="scss">
.square {
  background-color: #f6f6f6;
  padding: 0 34px 10px 34px;
  // overflow-y: scroll;
  // height: calc(100vh - 120px);
  // min-height: calc(100vh - 120px) ;
  &-tabs {
    position: relative;
    top: 20px;
    left: 50%;
    margin-left: -112px;
    margin-top: 20px;
    width: calc(66% - 20px);
    background-color: #4c4c4c;
    border-radius: 22px;
    position: relative;
    width: 224px;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
    &-item {
      position: absolute;
      cursor: pointer;
      width: 120px;
      text-align: center;
      font-size: 18px;
      color: #666;
      margin-top: -2px;
      border-radius: 22px;
         display: flex;
      align-items: center;
      justify-content: center;
      > span {
        display: inline-block;
        text-align: center;
        border-top-left-radius: 22px;
        border-bottom-left-radius: 22px;
        font-family: "AdobeHeitiStd-Regular";
        font-size: 14px;
        color: #fff;
        > img {
          margin-right: 6px;
        }
      }
    }
    .activeTab {
      width: 120px;
      border-radius: 22px !important;
      background-color: #2f82ff !important;
      z-index: 999;
      height: 42px;
      line-height: 42px
    }
  }
  &-search {
    background-color: #fff;
    border-radius: 22px;
    width: $xr-min-width;
    // margin-left: 17%;
    padding: 20px;
    margin-top: 20px;
  }
  &-data {
    @include fun-layout();
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    overflow: unset;
  }
}
.comCard2 {
  margin-right: 15px;
  margin-top: 20px;
}
// .comCard2:hover{
//    animation: run 2s;
// }

// @keyframes run{
//    0%{ transform:scale(1);}
//   100%{transform:scale(1.15);}
// }
.cell-item /deep/ .card1-content {
  padding: 5% 2%;
  margin-right: 20px;
}
.cell-item /deep/ .card1-img {
  margin-right: 20px;
}
.cell-item {
  width: 33%;
}
.square-title {
  height: 78px;
  background-color: #f6f6f6;
  width: $xr-min-width;
  position: sticky;
  top: 0;
  margin: 0 auto;
}
.nullData {
  margin: 0 auto;
  margin-top: 10vh;
  color: #909399;
}
.square /deep/ .el-dialog__body{
  height: calc(100% - 30px) !important;
}
.bar {
  .titles{
    font-weight: bolder;
    color: #333;
  }
  .content{
        width: 92%;
    display: inline-block;
  }
  .classify3content{
    display: flex;
    align-items: flex-start;
  }
   div {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
     button {
      margin-left: 10px;
      @include fun-design(8);
      border: none;
      padding: 10px !important;
    }
    .activeTab {
      margin-left: 10px;
      border-radius: 18px;
      font-size: 14px;
      @include fun-design(2)
    }
  }
}
</style>
